import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import DownloadAPK from 'views/external-pages/downloadAPK';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/authentication/login/Login')));
const AuthRegister = Loadable(lazy(() => import('views/authentication/enable-account/Register')));
const AuthForgotPassword = Loadable(lazy(() => import('views/authentication/forgot-password/ForgotPassword')));
const AuthCheckMail = Loadable(lazy(() => import('views/authentication/authentication/CheckMail')));
const AuthResetPassword = Loadable(lazy(() => import('views/authentication/reset-password/ResetPassword')));
const AuthCodeVerification = Loadable(lazy(() => import('views/authentication/auth-forms/CodeVerification')));
import Error404 from 'views/Pages/page-404';

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/',
            element: <AuthLogin />
        },
        {
            path: '/enable-account/:id',
            element: <AuthRegister />
        },
        {
            path: '/forgot-password',
            element: <AuthForgotPassword />
        },
        {
            path: '/pages/check-mail/check-mail',
            element: <AuthCheckMail />
        },
        {
            path: '/reset-password/:id',
            element: <AuthResetPassword />
        },
        {
            path: '/pages/code-verification/code-verification',
            element: <AuthCodeVerification />
        },
        {
            path: '/downloads/:id',
            element: <DownloadAPK />
        },
        {
            path: '*',
            element: <Error404 />
        },
        {
            path: "/pages-404",
            element: <Error404 />
        },

    ]
};

export default AuthenticationRoutes;
